export default __webpack_public_path__ + "static/media/fest.8fa378fc.jpg";